// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"3d047bcd","302":"19569f8d","389":"b512e3e7","874":"afb8bb4e"}[chunkId] + ".chunk.js";
};